export enum PENDO_ENVIRONMENT_IDENTIFIER {
  NON_PRODUCTION = 'non-production',
  PRODUCTION = 'production',
}

export const PROVIDER_RESULTS_SURVEY_DATE_LAST_SEEN_KEY = 'providerResultsSurveyDateLastSeen'
export const SHOW_PROVIDER_RESULTS_SURVEY_KEY = 'showProviderResultsSurvey'
